module.exports = __webpack_public_path__ + "img/category-new-released.2de20dae.png";